import { useEffect, useLayoutEffect, useRef, useState } from 'react';

export const ReadyClass = 'component-ready';
export default function useComponentReady(data: any, timeOut: number = 500) {
    const [componentReady, setComponentReady] = useState(false);

    //Fix for HChart reference
    const intervalRef = useRef(0);
    const [t, setT] = useState(0);
    const t2 = useRef(0);
    useEffect(() => {
        intervalRef.current = window.setInterval(() => {
            t2.current = t2.current + 1;
            setT(t2.current);
        }, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    useLayoutEffect(() => {
        if (!data) {
            return;
        }
        setTimeout(() => {
            document.body.classList.add(ReadyClass);
            setComponentReady(true);
            clearInterval(intervalRef.current);
        }, timeOut);
    }, [data, t2.current]);
    return componentReady;
}
